import { useState } from "react";
import { useNavigate } from "react-router-dom";

const SubmitOTP = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();
  const email = localStorage.getItem("email");

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalOtp = otp.join("");

    const res = await fetch("https://ankit1.jaskart.com/api/user/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp: finalOtp }),
    });

    const data = await res.json();

    if (!data.success) {
      alert("Invalid OTP");
      return;
    }

    localStorage.setItem(
      "user",
      JSON.stringify({
        id: data.user.id,
        email: data.user.email,
        sessionId: data.user.sessionId,
        session: "active",
      })
    );

    alert("Login successful!");
    navigate("/");
    window.location.reload();
  };

  return (
    <div
      className="container-fluid d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", background: "black" }}
    >
      <div className="row w-100 justify-content-center">
        <div className="col-11 col-sm-8 col-md-6 col-lg-4">
          <div
            className="p-4 rounded"
            style={{
              background: "white",
              boxShadow: "6px 6px gray",
            }}
          >
            <h3 className="text-center fw-bold mb-4">Verify OTP</h3>

            <form onSubmit={handleSubmit}>
              <div className="d-flex justify-content-between gap-2 mb-3">
                {otp.map((num, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    maxLength="1"
                    className="form-control text-center fs-4"
                    style={{
                      height: "55px",
                    }}
                    value={num}
                    onChange={(e) => handleChange(e.target.value, index)}
                  />
                ))}
              </div>

              <button
                className="btn btn-dark w-100 py-2"
                style={{ boxShadow: "6px 6px gray" }}
                type="submit"
              >
                Verify OTP
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmitOTP;
